import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';

import { icon, number } from '../../../../config';
import { getRelatedAssignmentListPayload, resetApprovalsDropdownNew } from './approval.helper';
import { getRelatedAssignmentList } from '../Details/taskDetail.helper';
import { getRelatedAssignedType } from '../../sidebar.helper';
import ApprovalAssignmentIdNew from './ApprovalAssignmentIdNew';
import ApprovalAssigneeNew from './ApprovalAssigneeNew';

/**
 * Parent component for assignment dropdown component, it is rendered in ApproverView Component 
 * @param {Object} props 
 * @author Himanshu Negi  
 * @returns JSX
 */
const ApprovalAssignment = (props) => {
  const { 
    approverAction, 
    approvalAssignType, 
    setApprovalAssignType, 
    approvalAssignId, 
    setApprovalAssignId, 
    approvalRelatedAssignedType, 
    setApprovalRelatedAssignedType, 
    approvalRelatedAssignedId, 
    setApprovalRelatedAssignedId, 
    relatedAssignedIdList, 
    setRelatedAssignedIdList, 
    approvalAssignee, 
    setApprovalAssignee, 
    approvalAssigneeName, 
    setApprovalAssigneeName,
    approvalSelection,
    setApprovalSelection,
    disable 
  } = props;

  const [initialRelatedAssignmentType, setInitialRelatedAssignmentType] = React.useState(null);
  const [initialRelatedAssignmentId, setInitialRelatedAssignmentId] = React.useState(null); 

  const { isNewTask } = useSelector((state) => state.taskSidebar)
  const { task } = useSelector(store => store.taskSidebar)
  const { defaultDetails } = useSelector(store => store.tasks)

  /**
   * sets initial values for approvals dropdowns
   */
  useEffect(() => {
    (async () => {
      if (isNewTask) return
      const assignedTypePayload = { 
        AssignedType: task?.approvalAssignedType, 
        AssignedId: task?.approvalAssignedId, 
        RelatedAssignedType: task?.approvalRelatedAssignedType 
      }
      const currentRelatedAssignedType = getRelatedAssignedType(assignedTypePayload);
      setInitialRelatedAssignmentType(currentRelatedAssignedType);
            
      const payload = getRelatedAssignmentListPayload(defaultDetails, currentRelatedAssignedType, task);
      const assignmentList = await getRelatedAssignmentList(payload);
      setInitialRelatedAssignmentId(
        assignmentList?.find((item) => 
          item.value === (currentRelatedAssignedType === number.TWO ? task?.approvalAssignee : task?.approvalRelatedAssignedId)
        )
      )
    })();
  }, [task?.taskId, task?.approvalAssignee]);

  /**
   * Returns all assignment states to its initial state if user cancels the reassignment
   * @param {Void}
   * @returns {Void}
   * @author Himanshu Negi
   */
  const handleCancelAssignment = async () => {
    const resetPayload = { 
      task, 
      setApprovalAssignType, 
      setApprovalAssignId, 
      setApprovalRelatedAssignedType, 
      setRelatedAssignedIdList, 
      setApprovalRelatedAssignedId, 
      setApprovalSelection,
      defaultDetails 
    }
    await resetApprovalsDropdownNew(resetPayload);   
  }

  /**
   * Check if assignment has changed from initial values
   * Uses embedded AssignmentType from approvalAssignId
   */
  const hasAssignmentChanged = () => {
    const currentAssignType = approvalAssignId?.AssignmentType;
    const currentAssignIdValue = approvalAssignId?.value;
    const currentRelatedAssignIdValue = approvalRelatedAssignedId?.value;
    
    return (
      currentAssignType !== task?.approvalAssignedType || 
      currentAssignIdValue !== task?.approvalAssignedId || 
      currentRelatedAssignIdValue !== initialRelatedAssignmentId?.value
    );
  }

  return (
    <React.Fragment>
      <div className='form-row'>
        
        {/* Merged DD1 + DD2 */}
        <ApprovalAssignmentIdNew
          approvalAssignType={approvalAssignType}
          setApprovalAssignType={setApprovalAssignType}
          approvalAssignId={approvalAssignId}
          setApprovalAssignId={setApprovalAssignId}
          setApprovalRelatedAssignedType={setApprovalRelatedAssignedType}
          setApprovalRelatedAssignedId={setApprovalRelatedAssignedId}
          setRelatedAssignedIdList={setRelatedAssignedIdList}
          approvalSelection={approvalSelection}
          setApprovalSelection={setApprovalSelection}
          disable={disable}
        />

        {/* Merged DD3 + DD4 */}
        <ApprovalAssigneeNew
          approvalAssignType={approvalAssignType}
          approvalAssignId={approvalAssignId}
          approvalRelatedAssignedType={approvalRelatedAssignedType}
          setApprovalRelatedAssignedType={setApprovalRelatedAssignedType}
          approvalRelatedAssignedId={approvalRelatedAssignedId}
          setApprovalRelatedAssignedId={setApprovalRelatedAssignedId}
          relatedAssignedIdList={relatedAssignedIdList}
          setRelatedAssignedIdList={setRelatedAssignedIdList}
          disable={disable}
        />

        <div className='cancel-assignment-icon position-absolute'>
          {hasAssignmentChanged() && (
            <span id='cancel-assignment' className='mb-2' onClick={handleCancelAssignment}>
              {icon.CLOSE}
            </span>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default ApprovalAssignment;
